export default "__VITE_ASSET__c7cd4540__"